<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="设备类型"
      edit-title
      id-key="EquipmentTypeId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="类型编码" prop="EquipmentNo">
          <el-input v-model="data.EquipmentNo" placeholder="请输入类型编码" />
        </el-form-item>
        <el-form-item label="类型名称" prop="EquipmentName">
          <el-input v-model="data.EquipmentName" placeholder="请输入类型名称" />
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        EquipmentTypeId: 0,
        EquipmentNo: "",
        EquipmentName: "",
      },
      api: require("@/api/ba/equipmentType").default,
      showList: [],
      rules: {
        EquipmentNo: [{ required: true, message: "请输入类型编码" }],
        EquipmentName: [{ required: true, message: "请输入类型名称" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
    
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },

    onEditOpened(data) {},

    onClosed() {
      this.showList = [];
    },
  },
};
</script>